import { Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { formatTitleCase } from 'src/app/shared/utility/common';
import { SupplierDetailedChargesTransactionHistoryModal } from '../supplier-detailed-charges-transaction-history-modal/supplier-detailed-charges-transaction-history-modal.component';

@Component({
    selector: 'app-campaign-add-charges-modal',
    templateUrl: './campaign-payment-transaction-history-modal.component.html',
    styleUrls: ['./campaign-payment-transaction-history-modal.component.scss']
})
export class CampaignPaymentTransactionHistoryModal implements OnInit {
    public form: FormGroup;
    public campaignId: string;
    dataSource = null;
    detailedTransactionDataSource;
    columns = [];
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    supplierTotalCharge;
    totalCampaignFees = 0;
    totalMfCharges = 0;
    footerCampaignColumns = ['f1c1', 'f1c2', 'f1c3', 'f1c4'];
    footerMfColumns = ['f2c1', 'f2c2', 'f2c3', 'f2c4'];

    private vatMultiplier = 1;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CampaignPaymentTransactionHistoryModal>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.dataSource = data.transactionDataSource;
        this.columns = data.columns;
        if (data.vat) {
            this.vatMultiplier = 1 + (data.vat / 100);
        }
        this.computeTotals();
    }

    ngOnInit(): void { }

    private computeTotals(): void {
        const rows = this.dataSource?.data || [];
        const campaignFeeTypes = ['CAMPAIGN_FEE', 'ADDITIONAL_CAMPAIGN_FEE'];

        const campaignFeesInclVat = rows
            .filter(r => campaignFeeTypes.includes(r.transactionType))
            .reduce((sum, r) => sum + (r.amount?.value || 0), 0);
        this.totalCampaignFees = campaignFeesInclVat / this.vatMultiplier;

        this.totalMfCharges = rows
            .filter(r => r.transactionType === 'MF_CHARGES')
            .reduce((sum, r) => sum + (r.amount?.value || 0), 0);
    }

    formatTransactionType(transactionType) {
        return `${formatTitleCase(transactionType)}${transactionType === "CAMPAIGN_FEE" ? "s" : ""}`;
    }

    getDetailedSupplierChargeTransactions(row) {
        if (row.supplierDetailedPaymentTransactions != null) {
            this.detailedTransactionDataSource = new MatTableDataSource(
                row.supplierDetailedPaymentTransactions
            );
            this.detailedTransactionDataSource.sort = this.sort;
            this.detailedTransactionDataSource.paginator = this.paginator;

            this.showCampaignDetailedTransactionHistory(
                this.detailedTransactionDataSource,
                ['transactionType', 'amount', 'createdAt'],
                row.supplierName,
                row.amount
            );
        }
    }

    showCampaignDetailedTransactionHistory(
        transactionDataSource,
        columns,
        supplierName,
        supplierTotalCharge
    ) {
        const dialogRef = this.dialog.open(SupplierDetailedChargesTransactionHistoryModal, {
            width: '90%',
            height: 'fit-content',
            data: { transactionDataSource, columns, supplierName, supplierTotalCharge }
        });
    }
}